<ng-container *ngIf="cs.vm$ | async as vm">
  <dgx-components-grid-section
    [theme]="'background-alternative'"
    [themeFlush]="true"
  >
    <dgx-components-grid-container class="pt-2">
      <dgx-components-grid-row>
        <dgx-components-grid-column [xs]="12" class="mb-8">
          <dgx-components-card
            [dropShadow]="true"
            [spacing]="5"
            class="landing__card"
          >
            <h1 class="landing__card-header">{{ vm.cmsData.pageTitle }}</h1>

            <dgx-components-grid-row class="mt-8">
              <dgx-components-grid-column
                [md]="6"
                [xs]="12"
                class="landing__checkout-guest"
              >
                <checkout-guest />
              </dgx-components-grid-column>

              <dgx-components-grid-column
                [md]="6"
                [xs]="12"
                class="landing__checkout-sign-in"
              >
                <checkout-sign-in-form (submitted)="cs.onFormSubmit($event)" />
              </dgx-components-grid-column>
            </dgx-components-grid-row>
          </dgx-components-card>
          <dgx-components-button-navigate-back />
        </dgx-components-grid-column>
      </dgx-components-grid-row>
    </dgx-components-grid-container>
  </dgx-components-grid-section>
</ng-container>
